<template>
  <v-container fluid>
    <v-layout column>
      <v-flex xs12>
        <v-card class="subheading pa-3 mt-3">
          <div class="title ma-2" style="display: flex;">
            <span style="margin-top:5px;">Reported Student List</span
            >&nbsp;&nbsp;&nbsp;
            <v-divider class="my-6" vertical></v-divider>
            <v-text-field
              style="margin-top:-14px; margin-bottom:-14px; margin-left: 20px;"
              type="number"
              v-model="reg_no"
              label="Search With Reg No"
              prepend-icon="search"
            ></v-text-field>
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn color="indigo" dark v-on="on" style="margin-top:-5px;">
                    <v-icon size="30" color="#fff">upload</v-icon>&nbsp;Upload
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title
                    class="headline indigo"
                    style="color:#fff;"
                    primary-title
                  >
                    Upload Reported Student List
                    <v-spacer></v-spacer>
                    <v-btn color="red" small dark fab @click="clearData()">
                      <v-icon color="#fff">close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md4>
                        <input
                          type="file"
                          accept=".xls,.xlsx"
                          @change="handleFileUpload"
                          ref="fileInput"
                        />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      style="margin-right: 41%;"
                      @click="submitFile"
                    >
                      Submit
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>
          <v-data-table
            :headers="headers"
            :items="filteredReportedData"
            class="elevation-1"
            :loading="loading"
            hide-actions
          >
            <template v-slot:items="{ item, index }">
              <tr>
                <td class="text-xs-center">{{ index + 1 }}</td>
                <td class="text-xs-left">{{ item.reg_no }}</td>
                <td class="text-xs-center">{{ item.exam_roll_no }}</td>
                <td class="text-xs-left">{{ item.reg_info.name }}</td>
                <td class="text-xs-left">
                  <v-text-field
                    v-model="item.reported_years"
                    disabled
                    label="Reported Years"
                  ></v-text-field>
                </td>
                <td>
                  <!-- <v-text-field
                    v-model="item.eligible_year"
                    :disabled="!item.is_edit"
                    type="number"
                    label="Eligible Year"
                  ></v-text-field> -->

                  <v-select
                    v-model="item.eligible_year"
                    :disabled="!item.is_edit"
                    :items="eligible_year"
                    label="Eligible Year"
                    :item-value="eligible_year.value"
                    :item-text="eligible_year.text"
                  ></v-select>
                  <!-- <v-autocomplete
                    class="ma-2"
                    v-model="item.eligible_year"
                    :items="eligible_year"
                    label="Eligible Year"
                    hide-details
                    :disabled="!item.is_edit"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        close
                        @click:close="item.eligible_year = ''"
                        :selected="data.selected"
                      
                      >
                        {{ data.item.text }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          data.item.text
                        }}</v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete> -->
                </td>
                <td>
                  <v-text-field
                    v-model="item.remarks"
                    :disabled="!item.is_edit"
                    label="Remarks"
                  ></v-text-field>
                </td>
                <td class="text-xs-center">
                  <v-btn
                    v-if="!item.is_edit"
                    fab
                    small
                    dark
                    color="#3F51B5"
                    @click="editItem(item)"
                  >
                    <v-icon color="#fff">edit</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="item.is_edit"
                    fab
                    small
                    dark
                    color="green"
                    @click="saveItem(item)"
                  >
                    <v-icon color="#fff">save</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="item.is_edit"
                    fab
                    small
                    dark
                    color="red"
                    @click="cancelEdit(item)"
                  >
                    <v-icon color="#fff">close</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import commonGet from "../../mixin/common_getters_mixin";
import commonExamYear from "../../mixin/exam_year_watch_mixin";
import common_login_getters from "../../mixin/common_login_getters";

export default {
  mixins: [commonGet, commonExamYear, common_login_getters],
  data() {
    return {
      reg_no: "",
      loading: false,
      searchParam: {},
      dialog: false,
      excelFile: null,
      headers: [
        { text: "Sl", value: "id" },
        { text: "Reg No", value: "reg_no" },
        { text: "Exam Roll", value: "exam_roll_no" },
        { text: "Name", value: "name" },
        { text: "Reported Years", value: "" },
        { text: "Eligible Year", value: "" },
        { text: "Remarks", value: "" },
        { text: "Action", value: "action" },
      ],
      items_status: [
        { key: "Correction", value: "correction" },
        { key: "New", value: "new" },
      ],
    };
  },
  computed: {
    getReportedData() {
      return this.$store.getters.getReportedStudentData;
    },
    filteredReportedData() {
      if (this.reg_no) {
        return this.getReportedData.filter((item) =>
          item.reg_no.toString().includes(this.reg_no.toString())
        );
      }
      return this.getReportedData;
    },
    // eligible_year() {
    //   const currentYear = parseInt(this.getLoggedInYear.year);
    //   const years = [];
    //   for (let i = 0; i < 5; i++) {
    //     years.push(currentYear + i);
    //   }
    //   return years;
    // },
    eligible_year() {
      const currentYear = parseInt(this.getLoggedInYear.year);
      const years = [];
      for (let i = 0; i < 5; i++) {
        const year = currentYear + i;
        years.push({
          value: JSON.stringify(year),
          text: `${year}`,
        });
      }
      return years;
    },
  },
  created() {
    this.getResultDataSet();
  },
  methods: {
    getResultDataSet() {
      this.loading = true;
      let param = {
        exam_initiate_id: this.getExamInitiateId,
        exam_code: this.getLoggedInExam.code,
        exam_year: this.getLoggedInYear.year,
      };
      this.$store.dispatch("fetchReportedStudent", param).then(() => {
        this.loading = false;
      });
    },
    editItem(item) {
      console.log(item);
      item.is_edit = true;
    },
    saveItem(item) {
      console.log("Saving item:", item);
      let pearm = {};
      pearm.id = item.id;
      pearm.reported_years = item.reported_years;
      pearm.eligible_year = item.eligible_year;
      pearm.remarks = item.remarks;
      this.$store.dispatch("updateReportedStudent", pearm).then(() => {
        item.is_edit = false;
        this.getResultDataSet();
      });
    },
    cancelEdit(item) {
      item.is_edit = false;
    },
    handleFileUpload(event) {
      this.excelFile = event.target.files[0];
    },
    submitFile() {
      if (!this.excelFile) {
        alert("Please select a file to upload");
        return;
      }
      // this.dialog = false;
      let pearm = {};
      pearm.exam_code = this.getLoggedInExam.code;
      pearm.exam_year = this.getLoggedInYear.year;
      pearm.rep_file = this.excelFile;
      this.$store.dispatch("uploadExcelFile", pearm).then(() => {
        this.getResultDataSet();
        this.dialog = false;
        this.excelFile = "";
      });
    },
    clearData() {
      this.excelFile = "";
      this.dialog = false;
    },
  },
};
</script>

<style scoped></style>
